import * as THREE from 'three';

export class Transform {
  position: THREE.Vector3;
  rotation: THREE.Quaternion;
  scale: THREE.Vector3;

  constructor(p?: {
    position?: THREE.Vector3;
    rotation?: THREE.Quaternion;
    scale?: THREE.Vector3;
  }) {
    this.position = p && p.position ? p.position : new THREE.Vector3();
    this.rotation = p && p.rotation ? p.rotation : new THREE.Quaternion();
    this.scale = p && p.scale ? p.scale : new THREE.Vector3(1, 1, 1);
  }

  asMatrix(): THREE.Matrix4 {
    return new THREE.Matrix4().compose(
      this.position,
      this.rotation,
      this.scale
    );
  }
}
